import React from 'react';
import { useTranslation } from 'react-i18next';

const LogOutModal = ({ show, handleClose, logoutHandler }) => {
  const {t} = useTranslation();
  const showHideClassName = show ? "custom-modal display-block" : "custom-modal display-none";

  return (
    <div className={showHideClassName} tabIndex="-1" role="dialog">
      <div className="custom-modal-dialog" role="document">
        <div className="custom-modal-content">
          <div className="custom-modal-header">
            <h5 className="custom-modal-title">{t('modal_LogOut')}</h5>
            <button type="button" className="close-btn" onClick={handleClose} aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="custom-modal-body">
            <p>{t('modal_Are_you')}</p>
          </div>
          <div className="custom-modal-footer">
            <button type="button" className="btn cancel-btn" onClick={handleClose}>
            {t('modal_Cancel')}
            </button>
            <button type="button" className="btn logout-btn" onClick={logoutHandler}>
            {t('modal_LogOut')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogOutModal;
